import { jsPDF } from "jspdf";

// Shared jsPDF builder for the admin manual and the public client guide.
export const buildManualPdf = (m) => {
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const left = 56;
  const width = W - left * 2;
  let y = 90;

  const newPage = () => { doc.addPage(); y = 70; };
  const need = (h) => { if (y + h > H - 60) newPage(); };

  doc.setFont("times", "bold");
  doc.setFontSize(24);
  doc.setTextColor(143, 51, 41);
  doc.text(m.title, left, y);
  y += 26;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(90, 87, 82);
  doc.text(m.subtitle, left, y);
  y += 26;
  doc.splitTextToSize(m.intro, width).forEach((line) => { need(16); doc.text(line, left, y); y += 15; });
  y += 10;

  m.sections.forEach((sec) => {
    need(50);
    doc.setFont("times", "bold");
    doc.setFontSize(15);
    doc.setTextColor(143, 51, 41);
    doc.text(sec.title, left, y);
    y += 18;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10.5);
    doc.setTextColor(45, 45, 45);
    sec.steps.forEach((step) => {
      const lines = doc.splitTextToSize(`•  ${step}`, width - 12);
      need(lines.length * 14 + 6);
      lines.forEach((line, i) => { doc.text(line, left + (i ? 12 : 0), y); y += 14; });
      y += 3;
    });
    y += 10;
  });

  const pages = doc.getNumberOfPages();
  for (let p = 1; p <= pages; p += 1) {
    doc.setPage(p);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(150, 145, 138);
    doc.text(`HR Creations · ${p}/${pages}`, W - left, H - 34, { align: "right" });
  }
  return doc;
};
